export const getBannerScrolledProps = () => {
    return {
        bannerName: 'banner_name',
        bannerAction: {
            key: 'banner_action',
            fn: () => 'scroll'
        },
        bannerId: 'banner_id',
        bannerType: 'banner_type',
        eventCategory: 'event_category'
    };
};
